import { createGraphqlFetcher } from '@apis/createFetcher';

const apis = {
    signup: {
        name: 'createUnionAccount',
        query: `mutation createUnionAccount($data:AccountCreateInput!, $where: AccountUnionWhereUniqueInput!) {
            createUnionAccount(data:$data, where:$where) {
                beFirstLogin,
                email
                i18n,
                id
                needSecondVerification,
                onlyPti,
                password
                ptiPwd
                ptiToken,
                ptiUid,
                signupSource
                status,
                token,
            }
        }`
    },
    validateEmail: {
        name: 'validateEmail',
        query: `query validateEmail($where: AccountWhereUniqueInput!) {
            validateEmail(where:$where)
        }`
    },
    updateUnionAccount: {
        name: 'updateUnionAccount',
        query: `mutation updateUnionAccount($data:AccountUpdateInput!, $where: AccountUnionWhereUniqueInput!) {
            updateUnionAccount(data:$data, where:$where) {
                id,
                email,
                beFromGoogle,
                ptiUid,
                ptiToken,
                token,
                signupSource,
                status,
                i18n,
                onlyPti,
                area,
                needSecondVerification,
                beFirstLogin,
                ptiPwd
            }
        }`
    },
    login: {
        name: 'newPtengineLogin',
        query: `query newPtengineLogin($data:AccountLoginInput!, $where: AccountUnionWhereUniqueInput!) {
            newPtengineLogin(data:$data, where:$where) {
                id,
                ptiUid,
                firstName,
                name,
                email,
                password,
                phone,
                industry,
                company,
                position,
                websiteType,
                token,
                hasActivated,
                hasAllow,
                createTime,
                activatedTime,
                updateTime,
                signupSource,
                permissionsDict,
                permissions,
                i18n,
                status,
                freeTrialLong,
                accountType,
                department,
                companySize,
                address,
                onlyPti,
                jobTitle,
                loginUtm,
                needSecondVerification,
                beFirstLogin,
                isProductIntroPopup,
                needGuide,
                ptiToken,
                ptiPwd,
                role,
                area,
                useType,
                beFromGoogle,
            }
        }`
    },
    superLogin: {
        name: 'newPtengineSuperLogin',
        query: `query newPtengineSuperLogin($where: SuperAccountWhereUniqueInput!) {
            newPtengineSuperLogin(where:$where) {
                id,
                email,
                ptiPwd
                ptiUid,
                ptiToken,
                token,
                signupSource,
                status,
                i18n
            }
        }`
    },
    verifyLoginCode: {
        name: 'googleSecondVerification',
        query: `
            query googleSecondVerification($code: String!){
                googleSecondVerification(code: $code)
            }
        `
    },
    logout: {
        name: 'logout',
        query: `query logout{
            logout
        }`
    },
    sendActiveEmail: {
        name: 'sendActiveEmail',
        query: `mutation sendActiveEmail($where: AccountWhereUniqueInput!){
            sendActiveEmail(where:$where)
        }`
    },
    activeAccount: {
        name: 'activeAccount',
        query: `mutation activeAccount($where: AccountWhereUniqueInput!){
            activeAccount(where:$where){
                id
                ptiUid
                name
                email
                password
                phone
                industry
                company
                position
                websiteType
                token
                hasActivated
                hasAllow
                createTime
                activatedTime
                updateTime
                signupSource
                permissionsDict
                permissions
                i18n
                status
                freeTrialLong
                accountType
                department
                companySize
                address
                onlyPti
                jobTitle
                loginUtm
                needSecondVerification
                beFirstLogin
                needGuide
                ptiToken
                ptiPwd
                area
                useType
                beFromGoogle
            }
        }`
    },
    activeUnionAccount: {
        name: 'activeUnionAccount',
        query: `mutation activeUnionAccount($input: AccountWhereUniqueInput!){
            activeUnionAccount(input: $input){
                id
                ptiUid
                name
                email
                password
                phone
                industry
                company
                position
                websiteType
                token
                hasActivated
                hasAllow
                createTime
                activatedTime
                updateTime
                signupSource
                permissionsDict
                permissions
                i18n
                status
                freeTrialLong
                accountType
                department
                companySize
                address
                onlyPti
                jobTitle
                loginUtm
                needSecondVerification
                beFirstLogin
                needGuide
                ptiToken
                ptiPwd
                area
                useType
                beFromGoogle
            }
        }`
    },
    createProfile: {
        name: 'createUnionProfile',
        query: `mutation createUnionProfile($data:UnionPtengineProfileCreateInput!) {
            createUnionProfile(data:$data) {
                ownerEmail,
                sid,
                siteid,
                type,
                name,
                domain,
                timeZone,
                createTime,
                updateTime,
                isActived,
                activeTime,
                profileSource,
                status,
                engageCount,
                engageRunningCount,
                usergroupCount,
                goalCount,
                currentUserRole,
                ptxUserRole,
                ptiUserRole,
                pteEnabled,
                ptxEnabled,
                ptengineCrossDomainSetting,
                sevenPV,
                sevenActiveUsers,
                consumedProfile,
                primaryDomain,
                campaignStatus,
                eventStatus,
                isNpPackage,
                isProductGuideBar
            }
        }`
    },
    updatePassword: {
        name: 'updatePasswordFromNewPtengine',
        query: `mutation updatePasswordFromNewPtengine($data:PasswordUpdateInput!,$where: AccountWhereUniqueInput!) {
            updatePasswordFromNewPtengine(data:$data, where:$where){
                id
                name
                email
                phone
                industry
                company
                position
                websiteType
                token
                hasActivated
                hasAllow
                createTime
                activatedTime
                updateTime
                signupSource
                permissionsDict
                permissions
                i18n
                status
                freeTrialLong
                accountType
            }
        }`
    },
    getAccountInfo: {
        name: 'getNewPtengineAccount',
        query: `
            query getNewPtengineAccount {
                getNewPtengineAccount {
                    id
                    ptiUid
                    ptiPwd
                    email
                    name
                    firstName
                    language
                    industry
                    companyName
                    companySize
                    department
                    jobTitle
                    role
                    telphone
                    address
                    totalProfile
                    consumedProfile
                    industryList
                    permissionsDict
                    permissions
                    area
                    beFromGoogle
                    useType
                    signupSource
                    isNpPackage
                }
            }`
    },
    updateAccountInfo: {
        name: 'updateAccountFromNewPtengine',
        query: `mutation updateAccountFromNewPtengine($data:NewPtengineAccountUpdateInput!) {
            updateAccountFromNewPtengine(data:$data){
                name
                email
            }
        }`
    },
    getBillingAccountConfig: {
        name: 'getNpBillAccountConf',
        query: `
            query getNpBillAccountConf($sid:String!) {
                getNpBillAccountConf(sid:$sid) {
                    email
                    name
                    company
                    address
                }
            }
        `
    },
    updateBillingAccountConfig: {
        name: 'modifyNpBillAccountConf',
        query: `
            mutation modifyNpBillAccountConf($data:NpBillAccountConfigModifyInput!,$sid:String!) {
                modifyNpBillAccountConf(params:$data,sid:$sid)
            }`
    },
    getProfilesWithPackageInfo: {
        name: 'getProfilesWithPackageInfo',
        query: `query getProfilesWithPackageInfo{
            getProfilesWithPackageInfo{
                profileId,
                profileName,
                packageId,
                packageName,
            }
        }`
    },
    getQRCode: {
        name: 'getQRCode',
        query: `query getQRCode($where: GoogleQRCodeWhereInput!) {
                getQRCode(where: $where){
                    qrcode,
                    secret
                }
            }`
    },
    getSecondVerificationAuthStatus: {
        name: 'getSecondVerificationAuthStatus',
        query: `query getSecondVerificationAuthStatus{
                    getSecondVerificationAuthStatus{
                        id,
                        uid,
                        secret
                    }
                }`
    },
    addSecondVerification: {
        name: 'addSecondVerification',
        query: `mutation addSecondVerification($data: SecondVerificationInput!) {
                addSecondVerification(data: $data)
            }`
    },
    deleteSecondVerification: {
        name: 'deleteSecondVerification',
        query: `mutation deleteSecondVerification{
                deleteSecondVerification
            }`
    },
    verifyQRCode: {
        name: 'verifyQRCode',
        query: `query verifyQRCode($where: GoogleVerifyQRCodeWhereInput!){
                verifyQRCode(where: $where)
            }`
    },
    getPtiPlanType: {
        name: '',
        query: `
            query verifyOnOffLineForPtengine{
                verifyOnOffLineForPtengine
            }
        `
    },
    createAccountForEn: {
        name: '',
        query: `mutation createUnionAccountForEn($data:EnAccountCreateInput!, $where: AccountUnionWhereUniqueInput!) {
            createUnionAccountForEn(data:$data, where:$where) {
                account{
                    id
                    ptiUid
                    firstName
                    name
                    email
                    password
                    phone
                    industry
                    company
                    position
                    websiteType
                    token
                    hasActivated
                    hasAllow
                    createTime
                    activatedTime
                    updateTime
                    signupSource
                    permissionsDict
                    permissions
                    i18n
                    status
                    freeTrialLong
                    accountType
                    department
                    companySize
                    address
                    onlyPti
                    jobTitle
                    loginUtm
                    needSecondVerification
                    beFirstLogin
                    needGuide
                    ptiToken
                    ptiPwd
                    role
                    area
                    useType
                    beFromGoogle
                }
                profile{
                    ownerEmail
                    sid
                    siteid
                    type
                    name
                    domain
                    timeZone
                    createTime
                    updateTime
                    isActived
                    activeTime
                    profileSource
                    status
                    engageCount
                    engageRunningCount
                    usergroupCount
                    goalCount
                    currentUserRole
                    ptxUserRole
                    ptiUserRole
                    pteEnabled
                    ptxEnabled
                    ptengineCrossDomainSetting
                    sevenPV
                    sevenActiveUsers
                    consumedProfile
                    primaryDomain
                }
            }
        }`
    },
    errorLog: {
        name: 'errorLog',
        query: `mutation errorLog($data: ErrorLogCreateUniqueInput!){
            errorLog(data: $data)
        }`
    },
    updateAccountPassword: {
        name: 'activeUpdatePassword',
        query: `mutation activeUpdatePassword($data: PasswordUpdateInput!, $where: AccountWhereUniqueInput!){
            activeUpdatePassword(data: $data, where: $where)
        }`
    },
    validateActiveSign: {
        name: 'validateActiveSign',
        query: `mutation validateActiveSign($where: AccountWhereUniqueInput!){
            validateActiveSign(where: $where)
        }`
    },
    validateUnionActiveSign: {
        name: 'validateUnionActiveSign',
        query: `mutation validateUnionActiveSign($input: AccountWhereUniqueInput!){
            validateUnionActiveSign(input: $input)
        }`
    },
    setProductActiveTime: {
        name: 'setProductActiveTime',
        query: `mutation setProductActiveTime($aid: String!, $product: String!) {
            setProductActiveTime(aid: $aid, product:$product)
        }`
    }
};

export default createGraphqlFetcher(apis);
